<style lang="scss" scoped>
.stepOne{
  background-color: #ebf6ff;
  border: 1px dashed #7bbcff;
  height: 434px;
  width: 674px;
  margin: 30px auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
#checkVideo {
  margin: 30px;
  ::v-deep video{
    width: 50%;
    height: 50%
  }
}

</style>
<template>
  <div class="stepOne">
    <div >
      <p><span>浏览器:</span>{{browser.name}}</p>
      <p><span>版本:</span>{{browser.version}}</p>
      <img :src="browserImg" alt="">
    </div>
    <p v-show="!browserOk">
      您的浏览器不符合考试要求，请下载最新Chrome浏览器。
      <a target="_blank" href="https://www.google.cn/chrome/">Chrome下载地址</a>
    </p>
  </div>
</template>
<script>
import codepku from '../../../utils/codepku';
import googleImg from '../../../assets/images/1.png';
import fireImg from '../../../assets/images/2.png';
import ieImg from '../../../assets/images/3.png';
import operaImg from '../../../assets/images/4.png';
import safariImg from '../../../assets/images/5.png';

const browser = codepku.browserType();
console.log(browser);
export default {
  data() {
 return {
    browser,
    browserOk: true,
  };
},
  methods: {

  },

  components: {},
  created() {},
  mounted() {
    const type = this.browser.type.toLowerCase();
    const version = parseInt(this.browser.version, 10);
    if ((type === 'chrome' && version >= 72)) {
      this.browserOk = true;
      this.$emit('browserReady');
    } else {
      this.browserOk = false;
    }
  },
  computed: {
    browserImg() {
      console.log(this.browser.type.toLowerCase());
      switch (this.browser.type.toLowerCase()) {
        case 'chrome':
          return googleImg;
        case 'firefox':
          return fireImg;
        case 'ie':
          return ieImg;
        case 'opera':
          return operaImg;
        case 'safari':
          return safariImg;
        default:
          return '';
      }
    },
  },
   props: {
    deviceStatus: {
      type: Object,
    },
    checkPassed: {
      type: [Boolean],
    },
  },
  watch: {},
};
</script>
